var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',{staticClass:"title subprimary"},[_c('v-spacer'),_vm._v(" Текущий диссертационный совет "),_c('v-spacer')],1),_c('LDissertation_council_member',{attrs:{"isDetail":true}}),_c('LDissertation_council_scientific_field',{attrs:{"isDetail":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }